import { object, string } from 'yup';

import { FIELD_IS_REQUIRED, INVALID_EMAIL } from '@/constants';

export const loginSchema = object({
  email: string().required(FIELD_IS_REQUIRED).email(INVALID_EMAIL),
  password: string().required(FIELD_IS_REQUIRED),
});
